import { toVariant, Variant } from '@faro/study-designer-model';
import axios from 'axios';
import { StudyPathParameter } from '../parameter';

export type VariantPathParameters = StudyPathParameter;
export type VariantQueryParameters = {
    readonly parentId?: string;
    readonly types?: string[];
    readonly schemaId?: string;
};

/**
 * Client responsible for accessing the backend variant entity services
 */
export const variantClient = {
    list: async (query: VariantPathParameters & VariantQueryParameters, signal?: AbortSignal): Promise<Variant[]> => {
        const { studyId, ...params } = query;
        const response = await axios.get(`/api/study-designer/studies/${studyId}/variants`, {
            signal,
            params,
        });
        return response.data.map(toVariant);
    },
    get: async (query: VariantPathParameters & { id: string }, signal?: AbortSignal): Promise<Variant> => {
        const { studyId, id, ...params } = query;
        const response = await axios.get(`/api/study-designer/studies/${studyId}/variants/${id}`, {
            signal,
            params,
        });
        return toVariant(response.data);
    },
};
